module.exports = __webpack_public_path__ + "img/intro2_logo_active.eeade1dd.png";